import React from 'react';
import { chemistryCalculators_Fr } from '../ConstantsChemistryCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices de chimie gratuites en ligne';
const DESCRIPTION = 'Calculez facilement le pH, la molarite, la dilution, la masse molaire, la densite et d autres valeurs de chimie avec des outils simples en francais.';
const KEYWORDS = 'calculatrice chimie, calcul pH, molarite, dilution, masse molaire, densite, calcul moles';
const OG_URL = 'https://do-calculate.com/fr/chemistry-calculators/';

function ChemistryCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>La page regroupe les principaux outils de chimie utilises en cours, en labo et pour les revisions.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {chemistryCalculators_Fr.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default ChemistryCalculatorsList;
